import React from 'react';
import { useLocation } from 'react-router-dom';
import cn from 'clsx';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import Checkbox from '../../../../library/checkbox/checkbox';

import {
  useCompareProducts,
  useProductEntryDataLayerValues,
  useTreadwellPreferences
} from '../../../../shared/hooks/hooks';

import { trackAction } from '../../../../shared/utils/analytics/analytics';
import { getTreadwellSelectorType } from '../../../../shared/utils/treadwell/treadwell';

import { PRODUCT_COMPARE_SELECTOR_TYPE } from '../../../../shared/constants/products';

import styles from './compare-checkbox.scss';

function CompareCheckbox(props) {
  const { className, hideSelectMoreText, product, quantity, rearQuantity } =
    props;

  const { search } = useLocation();
  const { page } = queryString.parse(search);

  const {
    maxProductsForComparison,
    onProductComparison,
    productsForComparison
  } = useCompareProducts();

  const { saveSearchTypes } = useTreadwellPreferences();

  const { getProductEntryDataLayerValues } = useProductEntryDataLayerValues();

  const selectedProducts = productsForComparison ? productsForComparison : [];
  const numProductsSelected = selectedProducts.length;
  const isSelectedForComparison = selectedProducts.some(
    p =>
      p?.code === product?.code &&
      p?.rearProduct?.code === product?.rearProduct?.code
  );
  const isDisabled =
    !isSelectedForComparison && numProductsSelected >= maxProductsForComparison;
  const moreProductsToSelect = maxProductsForComparison - numProductsSelected;

  function handleCheckboxClick() {
    onProductComparison(
      product,
      !isSelectedForComparison,
      quantity,
      rearQuantity,
      page
    );
    const treadwellSelectorType = getTreadwellSelectorType(
      product?.winterToggleStatus
    );
    const compareSelectorType = product?.recommendationData
      ? treadwellSelectorType
      : PRODUCT_COMPARE_SELECTOR_TYPE.ALL_TIRES;

    const productObj = {
      code: product?.code,
      compareSelectorType: compareSelectorType,
      shouldCheckExisting: true
    };
    saveSearchTypes(productObj);
    trackAction(
      `product_list_compare_${isSelectedForComparison ? 'remove' : 'add'}`,
      getProductEntryDataLayerValues(product)
    );
  }

  return (
    <div
      className={cn(styles['container'], `${className || ''} compare-checkbox`)}
    >
      <div
        className={cn(
          styles['compare-container'],
          `compare-checkbox__compare-container ${
            isDisabled ? 'compare-checkbox__compare-container--disabled' : ''
          }`
        )}
      >
        <Checkbox
          id="compare-btn"
          isChecked={isSelectedForComparison}
          isDisabled={isDisabled}
          label="Compare"
          onClick={handleCheckboxClick}
        />
      </div>

      {!hideSelectMoreText &&
        isSelectedForComparison &&
        moreProductsToSelect > 0 && (
          <span className={styles['select-more']}>
            {moreProductsToSelect === 1
              ? 'select 1 more'
              : `select up to ${moreProductsToSelect} more`}
          </span>
        )}
    </div>
  );
}

CompareCheckbox.propTypes = {
  className: PropTypes.string,
  hideSelectMoreText: PropTypes.bool,
  product: PropTypes.object,
  quantity: PropTypes.number,
  rearQuantity: PropTypes.number
};
export default CompareCheckbox;
